




















































import { Component, Prop, Vue } from 'vue-property-decorator';

// 导航菜单数据接口类型
interface headerListInterface {
  name: string;
  id: string;
  type: number;
  anchor: string;
  offsetTop: number;
}

@Component
export default class Header extends Vue {
  // 接收参数
  @Prop() public headerList!: headerListInterface[];
  @Prop() public activeIndex!: number;
  @Prop() public show!: boolean;
  public logoUrl = require('@/assets/image/logo.png'); //pc端logo
  public toggleUrl = require('@/assets/image/mobile_toggle.png'); //移动端logo
  public isToggle = false; // 默认不显示导航
  public isMobile = false; // 默认为pc端
  mounted() {
    // 判断是否是移动端
    if (window.innerWidth < 800) {
      this.isMobile = true;
    }
  }

  // 移动端显示隐藏导航菜单
  public toggle() {
    this.isToggle = !this.isToggle;
  }

  // 切换菜单
  public changeTab(item: headerListInterface) {
    console.log(item);
    if (item.type !== null) {
      this.isToggle = false;
      if (item.type === 0) {
        this.$emit('changeTab', item.anchor);
      } else if (item.type === 1 && item.anchor.length === 19) {
        this.$emit('jumpNewPage', item.anchor);
      } else if (item.type === 1) {
        this.$emit('jumpToIndependent');
      } else if (item.type === 2) {
        window.open(item.anchor);
      }
    }
  }
}
